






import { computed, defineComponent } from "@vue/composition-api";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import useHideMainMenu from "@/hooks/useHideMainMenu";
import { getProfileUrl } from "@/lib/urlHelpers";
import config from "@/config";
import BasePage from "@/components/BasePage";
import LoginComponent from "@/components/LoginComponent";

export default defineComponent({
  name: "PageLogin",
  components: { BasePage, LoginComponent },
  setup(_, { root }) {
    useHideMainMenu();

    const isSoloCreator = computed(() => !!config.soloCreatorId);

    const loginHandler = (user: User) => {
      if (user.role === "creator") {
        root.$router.push(getProfileUrl(user));
      } else {
        root.$router.push({ name: "home" });
      }
    };

    return {
      loginHandler,
      isSoloCreator,
    };
  },
});
